import { DashboardTopBar, TabsHandler, PageHead } from "shared";
import "./ProfilePage.scss";
import {
  PersonalData,
  ProfileMenu,
  AdressData,
  Payments,
  Communication,
  DeleteAccount,
  LoginOptions,
  Regulations,
} from "./components";
import { useState, useEffect } from "react";
import { useGetMe } from "hooks/auth";
import { isDesktop } from "utils";
import { useLocation, useSearchParams } from "react-router-dom";

export enum profileTabsEnum {
  "personal",
  "location",
  "communication",
  "payments",
  "loginOptions",
  "delete",
  "regulations",
}

const TAB_PARAM = "tab";

const TAB_PARAM_VALUES: Record<profileTabsEnum, string> = {
  [profileTabsEnum.personal]: "personal",
  [profileTabsEnum.location]: "location",
  [profileTabsEnum.communication]: "communication",
  [profileTabsEnum.payments]: "payments",
  [profileTabsEnum.loginOptions]: "loginOptions",
  [profileTabsEnum.delete]: "delete",
  [profileTabsEnum.regulations]: "regulations",
};

const TAB_FROM_PARAM: Record<string, profileTabsEnum> = {
  personal: profileTabsEnum.personal,
  location: profileTabsEnum.location,
  communication: profileTabsEnum.communication,
  payments: profileTabsEnum.payments,
  loginOptions: profileTabsEnum.loginOptions,
  delete: profileTabsEnum.delete,
  regulations: profileTabsEnum.regulations,
};

const ProfilePage = () => {
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const legacyTab = location.state?.tab;

  const getInitialTab = (): profileTabsEnum | null => {
    const paramTab = searchParams.get(TAB_PARAM);
    if (paramTab && paramTab in TAB_FROM_PARAM) {
      return TAB_FROM_PARAM[paramTab];
    }
    if (typeof legacyTab === "number") {
      return legacyTab;
    }
    return isDesktop() ? profileTabsEnum.personal : null;
  };

  const [tab, setTabState] = useState<profileTabsEnum | null>(
    getInitialTab(),
  );

  const handleSetTab = (newTab: profileTabsEnum | null) => {
    setTabState(newTab);
    const nextParams = new URLSearchParams(searchParams);
    if (newTab === null) {
      nextParams.delete(TAB_PARAM);
    } else {
      nextParams.set(TAB_PARAM, TAB_PARAM_VALUES[newTab]);
    }
    setSearchParams(nextParams, { replace: true });
  };

  useEffect(() => {
    if (tab !== null && !searchParams.get(TAB_PARAM)) {
      handleSetTab(tab);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { data: authorizedUser } = useGetMe();
  useEffect(() => {
    const html = document.documentElement;
    const dashboard = document.querySelector(".dashboard");
    if (!isDesktop() && tab !== null) {
      html.classList.add("no-scroll");
      dashboard?.classList.add("overflow-hidden");
    } else {
      html.classList.remove("no-scroll");
      dashboard?.classList.remove("overflow-hidden");
    }

    return () => {
      html.classList.remove("no-scroll");
    };
  }, [tab]);

  const getTabIndex = () => {
    switch (tab) {
      case profileTabsEnum.personal:
        return 0;
      case profileTabsEnum.location:
        return 1;
      case profileTabsEnum.communication:
        return 2;
      case profileTabsEnum.payments:
        return 3;
      case profileTabsEnum.loginOptions:
        return 4;
      case profileTabsEnum.delete:
        return 5;
      case profileTabsEnum.regulations:
        return 6;
      default:
        return -1;
    }
  };

  const handleGoBack = () => {
    handleSetTab(null);
  };

  return (
    <>
      <PageHead
        title="Profil użytkownika – zarządzanie kontem | App Reliance Pro"
        description="Zarządzaj danymi konta, preferencjami i płatnościami w aplikacji Reliance App."
      />
      <div className="profile">
        <DashboardTopBar>
          <h1 className="dashboard__header">Profil</h1>
        </DashboardTopBar>
        <div className="dashboard-content__wrapper">
          <div className="dashboard-content">
            <div className="profile__wrapper">
              <ProfileMenu tab={tab} setTab={handleSetTab} />
              <div className="profile__right">
                <TabsHandler currentTab={getTabIndex()}>
                  <PersonalData
                    handleGoBack={handleGoBack}
                    user={authorizedUser}
                  />
                  <AdressData
                    handleGoBack={handleGoBack}
                    user={authorizedUser}
                  />
                  <Communication
                    handleGoBack={handleGoBack}
                    user={authorizedUser}
                  />

                  <Payments handleGoBack={handleGoBack} user={authorizedUser} />
                  <LoginOptions
                    handleGoBack={handleGoBack}
                    user={authorizedUser}
                  />
                  <DeleteAccount
                    handleGoBack={handleGoBack}
                    user={authorizedUser}
                  />
                  <Regulations handleGoBack={handleGoBack} />
                </TabsHandler>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProfilePage;
